import { Guid } from "../../../types/guid.type";
import { EntityBase, IEntityBaseInfo } from "../../entity/entitybase";
import { IExportCell } from "../../entity/ientitybase.export";
import { IQuotationQuestionInfo, QuotationQuestion } from "../quotation-question";
import { Activity, IActivityInfo } from "../activity";
import { Identity, IIdentityInfo } from "../../identity/identity";

export interface IBusinessUnitInfo extends IEntityBaseInfo {

  Name?: string;
  ManagerUid?: Guid;
  Manager?: IIdentityInfo;
  ThirdPartCount?: number;
  AssociatedActivities?: IActivityInfo[];
  AssociatedQuotationQuestions?: IQuotationQuestionInfo[];
}

export class BusinessUnit extends EntityBase {

  Name?: string;
  ManagerUid?: Guid;
  Manager?: Identity;
  ThirdPartCount?: number;
  AssociatedActivities?: Activity[];
  AssociatedQuotationQuestions?: QuotationQuestion[];

  constructor(info: IBusinessUnitInfo) {
    super(info);

    this.Name = info.Name;
    this.ManagerUid = info.ManagerUid;
    this.Manager = Identity.createInstance(Identity, info.Manager);
    this.ThirdPartCount = info.ThirdPartCount;
    this.AssociatedActivities = info.AssociatedActivities?.map(aa => new Activity(aa)) ?? [];
    this.AssociatedQuotationQuestions = info.AssociatedQuotationQuestions?.map(aqq => new QuotationQuestion(aqq)) ?? [];

    this.Initials = this.getInitiales(this.Name);
    this.AvatarBackground = this.getSingleNameColor(this.Name);
  }

  override toCells(): IExportCell[] {
    return [
      <IExportCell>{ key: 'app.shared.name', value: this.Name, style: { fontSize: 8, width: 50 } },
    ];
  }
}
